var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSbpPayment = function SvgSbpPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sbp-payment_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5B57A2",
    d: "M1.693 4.334 3.63 7.797V9.91l-1.935 3.457z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D90751",
    d: "m9.133 6.537 1.816-1.113 3.716-.003-5.532 3.388z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB718",
    d: "m9.121 4.314.01 4.585L7.19 7.706V.85l1.932 3.463Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED6F26",
    d: "m14.663 5.42-3.716.004-1.826-1.11L7.19.85l7.474 4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63B22F",
    d: "M9.132 13.386V11.16L7.189 9.99l.002 6.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1487C9",
    d: "M10.944 12.283 3.63 7.797 1.693 4.334l12.963 7.944-3.713.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017F36",
    d: "m7.191 16.851 1.941-3.465 1.811-1.103 3.712-.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#984995",
    d: "M1.696 13.366 7.207 9.99 5.355 8.853 3.632 9.91z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sbp-payment_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.36.85h16v16h-16z"
  })))));
};
export default SvgSbpPayment;